module.exports = __webpack_public_path__ + "img/carousel-back--purple.9edd69a7.svg";